var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayout, usePopup, } from "@/hooks/layout";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { useGetCurrentUserQuery } from "@/store/api";
import { clearToken } from "@/store/authSlice";
import { useLogger } from "@/utils/loggerService";
import { Slot, SlotDirection } from "@/utils/types/layout";
import { faClose, faCogs, faCrateEmpty, faPortalExit, faTrashCanList, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuButton, Dropdown, Menu, MenuItem, ListItemDecorator, ListDivider, } from "@mui/joy";
import { useCallback, useState } from "react";
import "@/components/dev/placeholders";
import { slotDirection } from "@/utils/funcs";
export function DevMenu() {
    var _a;
    var _this = this;
    var _b, _c;
    var dispatch = useAppDispatch();
    var isAuthenticated = useAppSelector(function (state) { return state.auth.isAuthenticated; });
    var _d = useGetCurrentUserQuery(null), userResponse = _d.data, isLoading = _d.isLoading, isError = _d.isError, isFetching = _d.isFetching;
    var user = ((_b = userResponse === null || userResponse === void 0 ? void 0 : userResponse.data) === null || _b === void 0 ? void 0 : _b.record) || undefined;
    var logger = useLogger().logger;
    var popup = usePopup();
    var layout = useLayout();
    var slots = useAppSelector(function (state) { return state.layout.slots; });
    var slotKeys = Object.keys(slots);
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var handleOpenChange = useCallback(function (event, isOpen) {
        setOpen(isOpen);
    }, []);
    var verticalComponents = ["etcrm/widgets/default/menu"];
    var horizontalComponents = ["etcrm/widgets/default/menu"];
    var slotComponents = (_a = {},
        _a[SlotDirection.VERTICAL] = verticalComponents,
        _a[SlotDirection.HORIZONTAL] = horizontalComponents,
        _a);
    if (!isAuthenticated) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", __assign({ className: "absolute z-50 right-4 bottom-2" }, { children: _jsxs(Dropdown, __assign({ open: open, onOpenChange: handleOpenChange }, { children: [_jsx(MenuButton, __assign({ variant: "soft" }, { children: _jsx(FontAwesomeIcon, { icon: faCogs, className: "text-gray-900" }) })), _jsxs(Menu, __assign({ placement: "auto", className: "overflow-y-auto overflow-x-hidden max-h-[80vh]" }, { children: [slotKeys.map(function (slot) { return (_jsxs(MenuItem, { children: [_jsx(ListItemDecorator, { children: _jsxs("button", __assign({ className: "button  plain flex-auto", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                            var instance;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, layout.addWidget({
                                                            type: slot !== Slot.MODAL
                                                                ? slotComponents[slotDirection(slot)][0]
                                                                : "dev/confirm",
                                                            payload: { priority: 10 },
                                                            order: Math.random() * 100,
                                                            slot: slot,
                                                        })];
                                                    case 1:
                                                        instance = _a.sent();
                                                        logger.debug("[TEST] - COMPONENT INSTANCE: ", instance);
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); } }, { children: [_jsx(FontAwesomeIcon, { icon: faCrateEmpty, className: "mr-4" }), _jsx("span", __assign({ className: "mr-4" }, { children: slot }))] })) }), _jsx("button", __assign({ className: "button plain flex-none", onClick: function () {
                                        layout.clearWidgets({
                                            slots: [slot],
                                        });
                                    } }, { children: _jsx(FontAwesomeIcon, { icon: faTrashCanList }) }))] }, slot)); }), _jsx(ListDivider, {}), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/popup/delete/profile",
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[POPUP DEMO] - Popup widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW POPUP" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "widget/selector",
                                                slot: Slot.DRAWER_NORTH,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[DRAWER DEMO] - Drawer widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW DRAWER NORTH" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/popup/delete/profile",
                                                slot: Slot.DRAWER_SOUTH,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[DRAWER DEMO] - Drawer widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW DRAWER SOUTH" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/popup/delete/profile",
                                                slot: Slot.DRAWER_WEST,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[DRAWER DEMO] - Drawer widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW DRAWER WEST" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/popup/delete/profile",
                                                slot: Slot.DRAWER_EAST,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[DRAWER DEMO] - Drawer widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW DRAWER EAST" })), _jsx(ListDivider, {}), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/popup/delete/profile",
                                                slot: Slot.PREVIEW_NORTH,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[PREVIEW DEMO] - PREVIEW widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW PREVIEW NORTH" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/popup/delete/profile",
                                                slot: Slot.PREVIEW_SOUTH,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[PREVIEW DEMO] - PREVIEW widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW PREVIEW SOUTH" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/form/test",
                                                slot: Slot.PREVIEW_WEST,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[PREVIEW DEMO] - PREVIEW widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW PREVIEW WEST" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/form/test",
                                                slot: Slot.PREVIEW_EAST,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[PREVIEW DEMO] - PREVIEW widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "SHOW PREVIEW EAST" })), _jsx(ListDivider, {}), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/image/test",
                                                slot: Slot.HEADER_START,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[DOCK DEMO] - DOCK widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "IMAGE IN HEADER START" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/image/test",
                                                slot: Slot.MAIN,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[DOCK DEMO] - DOCK widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "IMAGE IN MAIN" })), _jsx(MenuItem, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, popup.showPopup({
                                                type: "dev/image/test",
                                                slot: Slot.FOOTER_START,
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            logger.debug("[DOCK DEMO] - DOCK widget Result: ", result);
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "IMAGE IN FOOTER START" })), _jsx(ListDivider, {}), _jsxs(MenuItem, __assign({ variant: "soft", color: "danger", onClick: function () {
                                layout.clearWidgets({
                                    slots: slotKeys,
                                });
                            } }, { children: [_jsx(ListItemDecorator, __assign({ sx: { color: "inherit" } }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "mr-4" }) })), "CLEAR_ALL"] })), _jsxs(MenuItem, __assign({ variant: "soft", color: "neutral", onClick: function () { return dispatch(clearToken()); } }, { children: [_jsx(ListItemDecorator, __assign({ sx: { color: "inherit" } }, { children: _jsx(FontAwesomeIcon, { icon: faPortalExit, className: "mr-4" }) })), "LOGOUT ", (_c = user === null || user === void 0 ? void 0 : user.attributes) === null || _c === void 0 ? void 0 : _c.full_name] }))] }))] })) })));
}
